import React, { useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
// import ReactDatePicker from "./ReactTimeIntervalPicker";
import { updateObject } from "../../../../helpers/updateObject";
import LinearProgress from "@material-ui/core/LinearProgress";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactSelect from "../../UI/ReactSelect";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3),
        padding: theme.spacing(2),
    },
    paper: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: "auto",
    },
    loading: {
        maxWidth: 500,
        justifyContent: "center",
        margin: "auto",
        padding: "16px 0",
    },
    circul: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
    },
    colorPrimaryCircul: {
        color: "##8950FC",
    },
    colorPrimary: {
        backgroundColor: "#8950fc99",
    },
    barColorPrimary: {
        backgroundColor: "#8950FC",
    },
    dashedColorPrimary: {
        backgroundColor: "#8950FC",
    },
}));

const ExportModal = (props) => {
    const classes = useStyles();
    const { onExport, exportLoading, exportParcent, show, onHide, assets, assetId, setAssetId } = props;


    const [filterInputs, setFilterInputs] = useState({
        assetId: assetId,
    });


    const assetsOptions = assets.map((suggestion) => ({
        value: suggestion.id,
        label: suggestion.name,
    }));


    const [assetsOption, setAssetsOption] = React.useState(null);
    function handleChangeAssets(value) {
        setAssetsOption(value);
        setAssetId(value.value)
    }


    const filterInputsUpdateKey = (key, value) => {
        const updateFiltersInput = updateObject(filterInputs, {
            [key]: value,
        });

        setFilterInputs(updateFiltersInput);
    };
    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Export Excel
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid">
                {!exportLoading && (
                    <Row>
                        <Col sm={12} md={12}>
                            <ReactSelect
                                suggestions={assetsOptions}
                                handleChangeSingle={handleChangeAssets}
                                single={assetsOption}
                                label="Choose asset"
                                placeholder="Choose asset"
                                inputId="assetId"
                                filterInputsUpdateKey={filterInputsUpdateKey}
                            />
                        </Col>
                    </Row>
                )}
                {exportLoading ? (
                    <div className={classes.loading}>
                        <div className={classes.circul}>
                            <CircularProgress
                                color="primary"
                                classes={{ colorPrimary: classes.colorPrimaryCircul }}
                            />
                        </div>
                    </div>
                ) : (
                    !exportLoading &&
                    exportParcent > 0 &&
                    exportParcent < 100 && (
                        <div className={classes.loading}>
                            <LinearProgress
                                variant="buffer"
                                value={exportParcent}
                                valueBuffer={exportParcent + 10}
                                color="primary"
                            />
                        </div>
                    )
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onHide} className="btn btn-light mr-3">Close</Button>
                <Button
                    variant="info"
                    onClick={() => onExport(filterInputs.startDate, filterInputs.endDate)}
                    className={exportLoading ? "px-9" : ""}
                >

                    <span>Download</span>
                    {exportLoading && <span className="ml-3 spinner spinner-white"></span>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ExportModal;

